import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, Checkbox, Input, Link, SpaceBetween, SplitPanel, Table } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { MenuItem } from '../../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const SystemSecurityRoutingPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [stage, setStage] = useState("A")
  const { data, parameters, menu, idAirport } = useGlobalState();
  const [usersGroups, setUsersGroups] = useState<any[]>([]);
  const [routings, setRoutings] = useState<any[]>([]);
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [menuSingle, setMenuSingle] = useState<MenuItem | null>(null);
  const [group, setGroup] = useState<any>();
  const [idGroup, setIdGroup] = useState<number>(0);
  const [filteredText, setFilteredText] = useState<string>("");
  const { navigate } = useRouter();

  const filtered = routings.filter((r: any) => r.route.toLowerCase().includes(filteredText.toLowerCase()) || r.routing.toLowerCase().includes(filteredText.toLowerCase()));

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");
      if (id) {
        setIdGroup(parseInt(id));
      }
      else {
        setGroup(null);
        setIdGroup(0);
        //handleUserGroups();
      }
      //handleGetEmail(id ? parseInt(id) : 0);
      //else
      //setMailTemplate(undefined);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {
    handleMenus();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      handleMenus();
    }, 500);
  }, [idAirport]);
  const handleMenus = async () => { // Make the function async
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/system/security/routing/menu',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setMenus(dataWeb.menus)
        setRoutings(dataWeb.routings)
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      console.log("END")
      setLoading(false)
    }
  }
  const handleUpdateUserGroup = async () => { // Make the function async
    try {
      console.log("handleUpdateUserGroup");
      if (!group) return;
      console.log(group)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/system/users/usergroups/update',
        },
        body: JSON.stringify({ idGroup: group.idGroup, jsonMenu: checkedIds }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        //setGroup(dataWeb.userGroup)
        //setMenu(dataWeb.menu)
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      console.log("END")
      setLoading(false)
    }
  }
  const handleUserGroups = async () => { // Make the function async
    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/system/users/usergroups/list',
        },
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setUsersGroups(dataWeb.userGroups)
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      console.log("END")
      setLoading(false)
    }
  }
  useEffect(() => {
    setGroup(null);
    //handleUserGroups();
  }, []);


  const handleUpdateMenu = async () => { // Make the function async
    try {
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/system/security/routing/update.menu',
        },
        body: JSON.stringify(menuSingle),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        if (dataWeb.menus) {
          setMenus(dataWeb.menus)
        }
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);
    } finally {
      console.log("END")
      setLoading(false)
    }
  }
  useEffect(() => {
    if (menuSingle?.jsonRouting)
      handleUpdateMenu();
  }, [menuSingle?.jsonRouting]);


  const [checkedItems, setCheckedItems] = React.useState<Record<number, boolean>>({});

  // When group.jsonMenu arrives, update checkedItems
  React.useEffect(() => {
    if (group?.jsonMenu) {
      const initial = group.jsonMenu.reduce((acc: Record<number, boolean>, id: number) => {
        acc[id] = true;
        return acc;
      }, {});
      setCheckedItems(initial);
    }
  }, [group?.jsonMenu]);

  const updateParentState = (
    updated: Record<number, boolean>,
    parentId: number | null
  ) => {
    if (!parentId) return;

    const parent = findItemById(menus, parentId);
    if (parent && parent.items) {
      const anyChildChecked = parent.items.some((c) => updated[c.idMenu]);
      updated[parent.idMenu] = anyChildChecked;

      // keep going up the tree
      const grandParent = findParentId(menus, parentId);
      updateParentState(updated, grandParent);
    }
  };
  const toggleChecked = (item: MenuItem, checked: boolean, parentId: number | null = null) => {
    setCheckedItems((prev) => {
      let updated = { ...prev, [item.idMenu]: checked };

      // if parent → toggle descendants
      if (item.items && item.items.length > 0) {
        const childIds = getDescendantIds(item);
        for (const cid of childIds) {
          updated[cid] = checked;
        }
      }

      // update parent(s)
      if (parentId !== null) {
        updateParentState(updated, parentId);
      }

      return updated;
    });
  };
  // Returns an array of descendant IDs (numbers)
  const getDescendantIds = (item: MenuItem): number[] => {
    let ids: number[] = [];
    if (item.items) {
      for (const child of item.items) {
        ids.push(child.idMenu);
        ids = ids.concat(getDescendantIds(child));
      }
    }
    return ids;
  };

  // Returns parent ID or null
  const findParentId = (
    items: MenuItem[],
    id: number,
    parentId: number | null = null
  ): number | null => {
    for (const item of items) {
      if (item.idMenu === id) return parentId;
      if (item.items) {
        const found = findParentId(item.items, id, item.idMenu);
        if (found !== null) return found;
      }
    }
    return null;
  };

  // Returns MenuItem or null
  const findItemById = (items: MenuItem[], id: number): MenuItem | null => {
    for (const item of items) {
      if (item.idMenu === id) return item;
      if (item.items) {
        const found = findItemById(item.items, id);
        if (found) return found;
      }
    }
    return null;
  };

  const renderMenu = (items: MenuItem[], parentId: number | null = null): JSX.Element => (
    <ul style={{ listStyle: "none", paddingLeft: "1em" }}>
      {items.map((item: MenuItem) => (
        <li key={item.idMenu}>
          {/*}
          <Checkbox
            checked={false}
            readOnly
          >
            */}
          <Link onClick={() => {
            setMenuSingle(item)
          }}>{item.text} [{item.jsonRouting?.length || 0}]</Link>
          {/*
          </Checkbox>
          */}

          {/* pass current item.idMenu as parentId for children */}
          {item.items && renderMenu(item.items, item.idMenu)}
        </li>
      ))}
    </ul>
  );

  const checkedIds: number[] = Object.keys(checkedItems || {})
    .filter((key) => checkedItems[Number(key)])
    .map((key) => Number(key));


  useEffect(() => {
    if (group && group.idGroup && checkedIds) {
      setTimeout(() => {
        handleUpdateUserGroup();
      }, 50);
    }
  }, [checkedIds]);
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={menuSingle !== null}
      onSplitPanelToggle={() => setMenuSingle(null)}
      splitPanel={<SplitPanel
        hidePreferencesButton
        header={`Enrutamiento ${menuSingle ? menuSingle.text : ""} [${menuSingle ? menuSingle.idMenu : ""}]`}>
        {menuSingle && (
          <SpaceBetween size="s" direction="vertical">
            <Table
              columnDefinitions={[
                {
                  id: 'idRouting', header: '', cell: item =>
                    <Checkbox
                      description={item.routing}
                      checked={menuSingle?.jsonRouting && menuSingle?.jsonRouting.includes(item.idRouting) || false}
                      onChange={(e) => {
                        if (!menuSingle) return;
                        let jsonRouting = menuSingle.jsonRouting ? [...menuSingle.jsonRouting] : [];
                        if (e.detail.checked) {
                          if (!jsonRouting.includes(item.idRouting)) {
                            jsonRouting.push(item.idRouting);
                          }
                        } else {
                          jsonRouting = jsonRouting.filter((id) => id !== item.idRouting);
                        }

                        setMenuSingle({
                          ...menuSingle,
                          jsonRouting
                        });
                      }}
                    >
                      {item.route}
                    </Checkbox>

                },
              ]}
              filter={<Input value={filteredText} placeholder="Filtrar rutas" onChange={e => setFilteredText(e.detail.value)} />}

              items={filtered}
              variant="embedded"
              stickyHeader
            />
            <Input value={filteredText} placeholder="Filtrar rutas" onChange={e => setFilteredText(e.detail.value)} />


          </SpaceBetween>
        )}
      </SplitPanel>}

      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }

      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={group ? <Button variant="link" href='#system/users/access'>Volver</Button> : null}>{group ? `Grupo ${group.groupName}` : "Módulos de acceso"}</Header>
          {menus && (
            renderMenu(menus)
          )}


        </SpaceBetween>
      }
    />
  )
};
